import { render, staticRenderFns } from "./DvStagger.vue?vue&type=template&id=81fd9e40&"
import script from "./DvStagger.vue?vue&type=script&lang=ts&"
export * from "./DvStagger.vue?vue&type=script&lang=ts&"
import style0 from "./DvStagger.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports